import React, { useState } from 'react';
import './Testimonials.css';
import quotationIcon from '../../assets/icons/qoutation.png';
import leftIcon from '../../assets/icons/left.png';
import rightIcon from '../../assets/icons/right.png';

const VISIBLE_COUNT = 3;

const Testimonials = () => {
    const [currentIndex, setCurrentIndex] = useState(0);

    const testimonials = [
        {
            text: "PFGS made my tax return process smooth and stress-free. I was surprised how quickly everything was handled — highly recommended!",
            name: "Sarah Malik",
            designation: "Business Owner"
        },
        {
            text: "We've been working with Mandeep and his team for over 3 years. They're always available, super professional, and know how to get results.",
            name: "Ravi Patel",
            designation: "Business Owner"
        },
        {
            text: "I love that I can reach out anytime during the year — not just at tax season. Their advice helped me save more than I expected.",
            name: "Ayesha Khan",
            designation: "Freelancer"
        },
        {
            text: "PFGS made my tax return process smooth and stress-free. I was surprised how quickly everything was handled — highly recommended!",
            name: "Sarah Malik",
            designation: "Business Owner"
        }
    ];

    const goToPrevious = () => {
        setCurrentIndex(currentIndex === 0 ? testimonials.length - 1 : currentIndex - 1);
    };

    const goToNext = () => {
        setCurrentIndex(currentIndex === testimonials.length - 1 ? 0 : currentIndex + 1);
    };

    const getVisibleTestimonials = () => {
        const visible = [];
        for (let i = 0; i < VISIBLE_COUNT; i++) {
            const index = (currentIndex + i) % testimonials.length;
            visible.push(testimonials[index]);
        }
        return visible;
    };

    return (
        <section className="testimonials">
            <div className="testimonials-container">
                <div className="testimonials-content">
                    <div className="testimonials-header">
                        <div className="testimonials-tag">Testimonials</div>
                        <h2 className="testimonials-title">
                            Real Feedback. <span className="text-primary">Real Results.</span>
                        </h2>
                        <p className="testimonials-description">
                            At PFGS, we take pride in the relationships we build with our clients. From individuals to business owners, here's what they have to say about our services:
                        </p>
                    </div>

                    <div className="testimonials-cards">
                        {getVisibleTestimonials().map((testimonial, index) => (
                            <div key={index} className="testimonial-card">
                                <div className="card-quotation">
                                    <img src={quotationIcon} alt="Quotation" className="quotation-icon" />
                                </div>
                                <p className="testimonial-text">{testimonial.text}</p>
                                <div className="testimonial-author">
                                    <h3 className="author-name">{testimonial.name}</h3>
                                    <p className="author-designation">{testimonial.designation}</p>
                                </div>
                            </div>
                        ))}
                    </div>

                    <div className="testimonials-navigation">
                        <button className="nav-button" onClick={goToPrevious}>
                            <img src={leftIcon} alt="Previous" className="nav-icon" />
                        </button>
                        <button className="nav-button" onClick={goToNext}>
                            <img src={rightIcon} alt="Next" className="nav-icon" />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Testimonials;